import script from "./ScrollContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollContainer.vue?vue&type=style&index=0&id=15f9a6bb&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f9a6bb"]])

export default __exports__